// Money (minor units like cents)
export function moneyFromMinor(value: number): number {
  return value / 100
}

export function moneyToMinor(value: number): number {
  return Math.round(value * 100)
}

// Currency rates (e.g. FX rate scaled by 10_000)
export function rateFromScaled(value: number): number {
  return value / 10_000
}

export function rateToScaled(value: number): number {
  return Math.round(value * 10_000)
}

// Convert currency rate to scaled integer unit
export function scaledFromRate(value: number): number {
  return rateToScaled(value)
}

// Percentages (e.g. 1250 = 12.50%)
export function percentFromScaled(value: number): number {
  return value / 100
}

export function percentToScaled(value: number): number {
  return Math.round(value * 100)
}

// Convert percentage rate to scaled integer unit
export function scaledFromPercent(value: number): number {
  return percentToScaled(value)
}

// Basis Points (e.g. 25 = 0.25%)
export function bpsFromScaled(value: number): number {
  return value / 10_000
}

export function bpsToScaled(value: number): number {
  return Math.round(value * 10_000)
}

export function formatMoney(value: number, decimals = 2): string {
  return value.toFixed(decimals)
}

export function formatPercent(value: number, decimals = 2): string {
  return Number(value.toFixed(decimals)).toString()
}

export function formatRate(value: number, decimals = 5): string {
  return Number(value.toFixed(decimals)).toString()
}